
<h1 mat-dialog-title>{{ 'payment' | translate | titlecase }}</h1>

<div mat-dialog-content>

    <div class="row no-gutters">
        <div class="col-10">
            <mat-form-field class="full-width">
                <mat-label>{{ 'detailed_processing.lawyer.title.payment.type' | translate }}</mat-label>
                <input id="{{idPrefix}}type"
                       matInput type="text"
                       [matAutocomplete]="paymentTypeAC"
                       [(ngModel)]="payment.type"
                       (ngModelChange)="updatePaymentTypeList($event)"
                       (blur)="onBlurPaymentType(payment)">
                <mat-autocomplete #paymentTypeAC="matAutocomplete"
                                  (opened)="paymentTypeSelectIsOpen = true"
                                  (closed)="paymentTypeSelectIsOpen = false"
                                  (optionSelected)="onBlurPaymentType(payment)">
                    <mat-option *ngFor="let item of filteredPaymentTypes; let idx = index"
                                id="{{idPrefix}}type.item_{{idx}}"
                                [value]="item">
                        {{ item }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

        <div class="col-2 align-self-center pl-4">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-10">
            <mat-form-field class="full-width">
                <mat-label>{{ 'detailed_processing.lawyer.title.payment.receiver' | translate }}</mat-label>
                <mat-select id="{{idPrefix}}receiver"
                            [(ngModel)]="payment.receiver"
                            [disabled]="receiverFieldDisabled">
                    <mat-option *ngFor="let receiver of data.paymentReceivers; let idx = index"
                                id="{{idPrefix}}receiver.item_{{idx}}"
                                [value]="receiver.code">
                        {{ receiver.displayName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-2 align-self-center pl-4">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-10">
            <mat-form-field class="full-width">
                <mat-label>{{ 'detailed_processing.lawyer.title.payment.amount' | translate }}</mat-label>
                <input id="{{idPrefix}}amount"
                       type="text" matInput currency
                       [(ngModel)]="payment.amount">
            </mat-form-field>
        </div>

        <div class="col-2 align-self-center pl-4">
            {{ currency.currency_display_name }}
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-10">
            <mat-form-field class="full-width">
                <mat-label>{{ 'detailed_processing.lawyer.title.payment.received' | translate }}</mat-label>
                <input id="{{idPrefix}}received"
                       type="text" matInput currency
                       [(ngModel)]="payment.received">
            </mat-form-field>
        </div>

        <div class="col-2 align-self-center pl-4">
            {{ currency.currency_display_name }}
        </div>
    </div>

    <div class="row no-gutters">
        <div class="col-10">
            <mat-form-field class="full-width">
                <mat-label>{{ 'detailed_processing.lawyer.title.payment.paid' | translate }}</mat-label>
                <input id="{{idPrefix}}paid"
                       type="text" matInput currency
                       [(ngModel)]="payment.paid">
            </mat-form-field>
        </div>

        <div class="col-2 align-self-center pl-4">
            {{ currency.currency_display_name }}
        </div>
    </div>

    <div class="row">
        <div class="col-10">
            <mat-form-field class="full-width">
                <mat-label>{{ 'detailed_processing.lawyer.title.payment.booking_date' | translate }}</mat-label>
                <input id="{{idPrefix}}booking_date"
                       matInput [matDatepicker]="pickerBookingDate"
                       [(ngModel)]="payment.booking_date">
                <mat-datepicker-toggle matSuffix [for]="pickerBookingDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerBookingDate></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-2 align-self-center pl-4">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
        </div>
    </div>

    <div class="row">
        <div class="col-10">
            <mat-form-field class="full-width">
                <mat-label>{{ 'detailed_processing.lawyer.title.payment.payment_target' | translate }}</mat-label>
                <input id="{{idPrefix}}payment_target"
                       matInput [matDatepicker]="pickerPaymentTarget"
                       [(ngModel)]="payment.payment_target">
                <mat-datepicker-toggle matSuffix [for]="pickerPaymentTarget"></mat-datepicker-toggle>
                <mat-datepicker #pickerPaymentTarget></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-2 align-self-center pl-4">
            <!-- PLACEHOLDER FOR ACTION BUTTONS-->
        </div>
    </div>

</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6 no-gutters pl-0">
        <button id="{{idPrefix}}btn.ok" mat-raised-button class="full-width" color="accent" (click)="accept()">{{ 'common.btn.ok' | translate }}</button>
    </div>

    <div class="col-sm-6 no-gutters pr-0">
        <button id="{{idPrefix}}btn.cancel" mat-stroked-button color="primary" class="full-width" (click)="close()">{{ 'common.btn.cancel' | translate }}</button>
    </div>

</div>
